import { css } from '@emotion/react'
import { Link, graphql } from 'gatsby'
import { ComponentPropsWithoutRef } from 'react'

import { GatsbyImageFocused } from '@/features/common/'
import { bezier, mq, scrim } from '@/theme/mixins'

interface Props extends ComponentPropsWithoutRef<'a'> {
  data?: Queries.AdmissionDoorwayFragment | null
}

export const AdmissionDoorway = ({
  data,
  ...props
}: Props): JSX.Element => {
  const styles = {
    link: css`
      display: grid;
      position: relative;
      text-decoration: none;
      min-height: 33vw;
      ${mq().s} {
        min-height: 60vw;
      }
    `,
    image: css`
      position: absolute;
      grid-column: 1 / 2;
      grid-row: 1 / 2;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      background: #000;
      [data-gatsby-image-wrapper] {
        transition:
          transform 500ms ${bezier.easeOut},
          opacity 500ms ${bezier.easeOut};
        opacity: 0.85;
        @media (hover: hover) {
          a:hover & {
            transform: scale3d(1.05, 1.05, 1);
            opacity: 1;
          }
        }
      }
      &:after {
        content: '';
        background: ${scrim('#000', 0.5, 'to top')};
        position: absolute;
        left: 0;
        bottom: 0;
        height: 100%;
        width: 100%;
      }
    `,
    heading: css`
      position: relative;
      font-size: var(--fs-54);
      color: #fff;
      align-self: center;
      justify-self: center;
      text-align: center;
      margin: 1em 0.25em;
      text-shadow: 0 0 0.25em #00000088;
    `,
  }
  return (
    <Link
      to={`/${data?.link?.slug}/`}
      css={styles.link}
      {...props}
    >
      {data?.image && (
        <GatsbyImageFocused
          data={data?.image}
          image={data?.image.gatsbyImageData}
          aspectRatio={2 / 3}
          css={styles.image}
        />
      )}
      <h3 css={styles.heading}>{data?.heading}</h3>
    </Link>
  )
}

export const AdmissionDoorwayFragment = graphql`
  fragment AdmissionDoorway on DatoCmsAdmissionDoorway {
    id: originalId
    __typename
    heading
    image {
      ...ImageFocalData
      gatsbyImageData(
        imgixParams: {
          fit: "crop"
          crop: "focalpoint"
          ar: "2:3"
          q: 65
        }
        width: 480
        sizes: "(max-width: 540px) 60vw, 33vw"
      )
    }
    link {
      slug
    }
  }
`
